import styled from 'styled-components';

const StarTextDiv = styled.div`
  margin-bottom: 14px;
  margin-left: 12px;
  font-size: 15px;
  color: #173c51;
`;
export default StarTextDiv;
